import React from 'react';
import { useModalsContext } from '/src/providers';
import * as styles from './styles.scss'

const ImageZoom = ({ url }) => {
    const { hideModal } = useModalsContext();

    return (
        <div className={styles.modal}>
            <div
                className={styles.back}
                onClick={hideModal}
                role="presentation"
            />
            <div
                className={styles.border}
                onClick={hideModal}
            >
                <div className={styles.wrap}>
                    <img
                        className={styles.img}
                        src={url}
                        alt=""
                    />
                </div>
            </div>
        </div>
    )
};

export default ImageZoom;
